type ArrowButtonProps = {
  onClick: () => void;
  position: "left" | "right";
  icon: string;
};

export const ButtonArrow = ({ onClick, position, icon }: ArrowButtonProps) => (
  <button
    onClick={onClick}
    className={`absolute top-1/2 ${
      position === "left" ? "left-0 md:left-4" : "right-0 md:right-4"
    } -translate-y-1/2 px-4 py-2 text-white bg-white/30 hover:bg-black/30 transition rounded-lg z-10`}
  >
    <img
      src={icon}
      alt={`${position} arrow`}
      className="w-8 h-8 lg:w-12 lg:h-12"
    />
  </button>
);
